module.exports = __webpack_public_path__ + "img/successfull-1.cdc2f815.png";